/* eslint-disable no-plusplus */
/* eslint-disable no-sequences */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable valid-typeof */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unescaped-entities */
import React, { Suspense, lazy } from 'react';
import { lazily } from 'react-lazily';

import {
    Navigate, Route, Routes, useLocation,
} from 'react-router-dom';
import { AdminUsers } from '../pages/AdminUsers';
import { UpdateAdminUser } from '../pages/AdminUsers/UpdateAdminUser';
import { DistributorManagement } from '../pages/DistributorManagement';
import ViewDistributor from '../pages/DistributorManagement/ViewDistributor';
import Layout from '../Components/Layout';
import { Login } from '../Components/Login';
import { ManageCategories } from '../pages/ManageCategories';
import { ManageOffers } from '../pages/ManageOffers';
import { CreateOffer } from '../pages/ManageOffers/CreateOffer';
import ViewOffer from '../pages/ManageOffers/ViewOffer';
import { ManageDap } from '../pages/ManageDap';
import HandleDapCrud from '../pages/ManageDap/HandleDAPCrud';
import ViewDap from '../pages/ManageDap/ViewDap';
import ManageOrders from '../pages/ManagerOrders';
import ManagePendingApprovalList from '../pages/ManagerOrders/ManagePendingApprovals';
import ManageAdorCash from '../pages/AdorCashManagement';
import ViewAdorCashDetails from '../pages/AdorCashManagement/ViewAdorCashDetails';
import ManageApprovedOrders from '../pages/ManageApprovedOrders/ApprovedOrders';
import ViewApprovedOrdersDetails from '../pages/ManageApprovedOrders';
import ProductsListings from '../pages/ManageApprovedOrders/Components/ProductsListing';
import Cart from '../pages/ManageApprovedOrders/Components/CartPage';
import OrderDetailsForm from '../pages/ManageApprovedOrders/Components/OrderDetailsForm';
import ManageCancelledOrders from '../pages/ManageCancelledOrders';
import ShippingOrganizations from '../pages/ShippingOrganizations';
import PendingOrderStatementReport from '../pages/MISReports/PendingOrder';
import CategoryManagement from '../pages/Resources/CategoryManagement';
import ResourceManagement from '../pages/Resources/ResourceManagement';
import CustomerWiseOutstandingReport from '../pages/MISReports/CustomerWiseReport';
import Dashboard from '../pages/Dashboard';
import Invoices from '../pages/ManageApprovedOrders/Components/Invoices/invoices';
import ManageInvoices from '../pages/Invoices';
import AreaWiseCustomerOutstandingReport from '../pages/MISReports/AreaWiseCustomerReport';
import FGStockDetails from '../pages/MISReports/FGStockDetails';
import IndentReport from '../pages/MISReports/IndentReport';
import OutstandingInvoiceSkeleton from '../pages/MISReports/OutstandingInvoiceReport/outstandingInvoiceSkeleton';
import OutstandingInvoiceDetailsReport from '../pages/MISReports/OutstandingInvoiceReport';
import InvoiceReport from '../pages/MISReports/InvoiceReport';
import ViewCustomerOutstandingInvoice from '../pages/MISReports/CustomerWiseReport/ViewCustomer';
import ManageTransactions from '../pages/Transactions';
import ManageCreditDebitDetails from '../pages/CreditDebitDetails';
import ViewAreaWiseReport from '../pages/MISReports/AreaWiseCustomerReport/ViewAreaWiseReport';
import PromotionList from '../pages/PromotionsAndCampaigns';
import FormulaSettings from '../pages/FormulaSettings';
import ManageReturnRequests from '../pages/ReturnRequest';
import StockListing from '../pages/Stock';
import ProductPriceList from '../pages/ProductPriceList';
import BulkOfferListing from '../pages/BulkOffer';
import { CreateBulkOffer } from '../pages/BulkOffer/createBulkOffer';
import ViewBulkOffer from '../pages/BulkOffer/ViewBulkOffer';
import ViewSubscribers from '../pages/BulkOffer/ViewSubscribers';
import BulkInvoiceListing from '../pages/BulkOffer/BulkInvoiceListing';
import ProductListing from '../pages/ProductListing';
import SubscribedBulkOrders from '../pages/BulkOffer/subscribedOrders';
import IPOrderReport from '../pages/IPOrderReport';
// import ProductListing from '../pages/ProductListing';

// const AdminUsers = lazy(() => import('../Components/AdminUsers').then((module) => ({ default: module.AdminUsers()})));
// const CreateNewAdminUser = lazy(() => import('../Components/AdminUsers/CreateNewAdminUser'));
// const UpdateAdminUser = lazy(() => import('../Components/AdminUsers/UpdateAdminUser'));
// const Layout = lazy(() => import('../Components/Layout').then((module) => ({ default: module[Layout] })));
// const DistributorManagement = lazy(() => import('../Components/DistributorManagement'));
// const ViewDistributor = lazy(() => import('../Components/DistributorManagement/ViewDistributor'));
// const Login = lazy(() => import('../Components/Login'));
// const ManageCategories = lazy(() => import('../Components/ManageCategories'));
// const ManageOffers = lazy(() => import('../Components/ManageOffers'));
// const CreateOffer = lazy(() => import('../Components/ManageOffers/CreateOffer'));
// const ViewOffer = lazy(() => import('../Components/ManageOffers/ViewOffer'));

export default function NavigationRoutes(props) {
    const location = useLocation();
    const { loggedIn } = props;
    const allRoutes = {
        'admin_users:list': <Route path="/manage-internal-users" element={<AdminUsers />} />,
        view_dashboard: <Route path="/" element={<Dashboard />} />,
        'admin_users:create': <Route path="/manage-internal-users/create-admin-user" element={<UpdateAdminUser />} />,
        'admin_users:update': <Route path="/manage-internal-users/:email/edit" element={<UpdateAdminUser isUpdate />} />,
        'distributor:list': <Route path="/distributors" element={<DistributorManagement />} />,
        'distributor:view': <Route path="/distributors/:id/view" element={<ViewDistributor />} />,
        'distributor:update': <Route path="/distributors/:id/update" element={<ViewDistributor isUpdate />} />,
        'deals:list': <Route path="/manage-offers" element={<ManageOffers />} />,
        'deals:create': <Route path="/manage-offers/create-new-offer" element={<CreateOffer />} />,
        'deals:view': <Route path="/manage-offers/view" element={<ViewOffer />} />,
        'deals:update': <Route path="/manage-offers/:update_id/update" element={<CreateOffer isUpdate />} />,
        view_categories: [<Route path="/manage-categories" element={<ManageCategories />} />, <Route path="/product-listing" element={<ProductListing />} />],
        'dap:list': <Route path="/manage-freight-policy" element={<ManageDap />} />,
        'dap:create': <Route path="/manage-freight-policy/create-new-dap" element={<HandleDapCrud />} />,
        'dap:update': <Route path="/manage-freight-policy/:update_id/update" element={<HandleDapCrud isUpdate />} />,
        'dap:view': <Route path="/manage-freight-policy/:id/view" element={<ViewDap />} />,
        'pending_approvals:manage_pending_view': <Route path="/manage-pending-approvals" element={<ManagePendingApprovalList />} />,
        'pending_approvals:manage_pending_approvals': <Route path="/manage-pending-approvals/:distributorId/:orderId/view/" element={<ManageOrders />} />,
        'cashback:list': <Route path="/ador-cash-management" element={<ManageAdorCash />} />,
        'cashback:view': <Route path="/ador-cash-management/:distributor_id/view" element={<ViewAdorCashDetails />} />,
        'orders:list': <Route path="/manage-orders" element={<ManageApprovedOrders />} />,
        'orders:view': <Route path="/manage-orders/:distributorId/:orderId/view" element={<ViewApprovedOrdersDetails />} />,
        'orders:create_direct_order': [<Route path="/manage-orders/direct-order/:distributorId/:orderId/edit" element={<ProductsListings />} />,
            <Route path="/manage-orders/direct-order/:distributorId/:orderId/edit/cart" element={<Cart />} />,
            <Route path="/manage-orders/direct-order/:distributorId/:orderId/edit/order-details" element={<OrderDetailsForm />} />],
        'orders:cancel': [<Route path="/cancelled-orders" element={<ManageCancelledOrders />} />,
            <Route path="/cancelled-orders/:distributorId/:orderId/view" element={<ViewApprovedOrdersDetails />} />],
        view_3pls: <Route path="/shipping-organization" element={<ShippingOrganizations />} />,
        manage_resources: [<Route path="/resource/category-management" element={<CategoryManagement />} />,
            <Route path="/resource/resource-management" element={<ResourceManagement />} />],
        mis_reports: [<Route path="/mis-reports/pending-order-statement-report" element={<PendingOrderStatementReport />} />,
            <Route path="/mis-reports/customer-wise-outstanding-report" element={<CustomerWiseOutstandingReport />} />,
            <Route path="/mis-reports/customer-wise-outstanding-report/:id" element={<ViewCustomerOutstandingInvoice />} />,
            <Route path="/mis-reports/area-wise-customer-outstanding-report" element={<AreaWiseCustomerOutstandingReport />} />,
            <Route path="/mis-reports/specific-area-wise-customer-outstanding-report/:id" element={<ViewAreaWiseReport />} />,
            <Route path="/mis-reports/fg-stock-details" element={<FGStockDetails />} />,
            <Route path="/mis-reports/indent-report" element={<IndentReport />} />,
            <Route path="/mis-reports/outstanding-invoice-details-report" element={<OutstandingInvoiceDetailsReport />} />,
            <Route path="/mis-reports/invoice-report" element={<InvoiceReport />} />],
        'invoices:list': [<Route path="/invoices" element={<ManageInvoices />} />,
            <Route path="/return-requests" element={<ManageReturnRequests />} />],
        'credit_debit:list': <Route path="/credit-debit-details" element={<ManageCreditDebitDetails />} />,
        'transactions:list': <Route path="/transactions" element={<ManageTransactions />} />,
        manage_banners: <Route path="/promotion" element={<PromotionList />} />,
        manage_settings: <Route path="/system-setup-menu" element={<FormulaSettings />} />,
        stock_inventory: <Route path="/stock" element={<StockListing />} />,
        price_list: <Route path="/product-list-price" element={<ProductPriceList />} />,
        bulk_offer: [<Route path="/bulk-offers" element={<BulkOfferListing />} />,
            <Route path="/bulk-offers/create" element={<CreateBulkOffer />} />,
            <Route path="/bulk-offers/view" element={<ViewBulkOffer />} />,
            <Route path="/bulk-offers/invoices" element={<BulkInvoiceListing />} />,
            // <Route path="/product-listing" element={<ProductListing />} />,
            <Route path="/bulk-offers/:update_id/update" element={<CreateBulkOffer isUpdate />} />,
            <Route path="/bulk-offers/subscribers/:id" element={<ViewSubscribers />} />,
            <Route path="/bulk-offers/subscribered-orders/:id/:disId" element={<SubscribedBulkOrders />} />],
        ip_order_report: <Route path="/ip-order-report" element={<IPOrderReport />} />,
    };
    let privilages = [];
    if (loggedIn) {
        const currentUserPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.access_privilages || [];
        for (let index = 0; index < currentUserPrevilages.length; index++) {
            if (Object.keys(allRoutes).includes(currentUserPrevilages[index]) && typeof allRoutes[currentUserPrevilages[index]] === typeof []) {
                privilages = privilages.concat(allRoutes[currentUserPrevilages[index]]);
            } else if (Object.keys(allRoutes).includes(currentUserPrevilages[index]) && typeof allRoutes[currentUserPrevilages[index]] !== typeof []) {
                privilages.push(allRoutes[currentUserPrevilages[index]]);
            }
        }
    }
    return (
    // <Suspense fallback={<div>Loading...</div>}>

        <Routes location={location} key={location.pathname}>

            <Route
                path="*"
                element={(
                    <main style={{ padding: '1rem' }}>
                        <p>There's nothing here!</p>
                        <a><Navigate to="/" replace /></a>
                    </main>
                )}
            />
            {!loggedIn ? (
                <Route path="/" element={<Login />} />
            ) : (
                <Route element={<Layout {...props} />}>
                    {privilages}
                </Route>
            )}

        </Routes>
        // </Suspense>

    );
}
